import { getLocale } from "../runtime";

const sv_deliverystartsat = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Frakt från`
};

const deliverystartsat = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_deliverystartsat(inputs)
	return "deliveryStartsAt";
};

export { deliverystartsat as "deliveryStartsAt" };